import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons/faAngleDown';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons/faAngleUp';
import { faCircleUser } from '@fortawesome/free-solid-svg-icons/faCircleUser';
import { detectDeviceType, handleTabAction } from '../../utils/helpers';

const ProfileIcon = ({
  isProfileMenuOpen,
  handleProfileMenuClick,
  userName,
}: any) => {
  const userMenuIcon = isProfileMenuOpen ? faAngleUp : faAngleDown;
  return (
    <div
      className="profile-menu-wrapper desktop-profile"
      aria-label="user profile menu link"
      tabIndex={0}
      onKeyDown={(e) => handleTabAction(e, handleProfileMenuClick)}
    >
      <div className="profile-icon-wrapper">
        <span className="profile-name">{userName}</span>
        <FontAwesomeIcon
          className="profile-icon"
          icon={faCircleUser}
          data-type={detectDeviceType}
          data-reason="profile"
          data-object="button"
          data-channel={isProfileMenuOpen ? 'closeProfile' : 'openProfile'}
          onClick={handleProfileMenuClick}
        />
      </div>
      <FontAwesomeIcon
        icon={userMenuIcon}
        className="user-menu-down-arrow"
        data-testid="user-menu-down-arrow"
        data-type={detectDeviceType}
        data-reason="profile"
        data-object="button"
        data-channel={isProfileMenuOpen ? 'closeProfile' : 'openProfile'}
        onClick={handleProfileMenuClick}
      />
    </div>
  );
};
export default ProfileIcon;
